import React from "react";
import Navbar from '../src/components/NavBar'
import HomeSection from "./components/HomeSection";
import AboutUsSection from "./components/AboutUsSection";
import ProjectsSection from "./components/ProjectsSection";
import FeaturesSection from "./components/FeaturesSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const App = () => (
  <div>
    <Navbar />
    <HomeSection />
    <AboutUsSection />
    <ProjectsSection />
    <FeaturesSection />
    <ContactSection />
    <Footer />
  </div>
);

export default App;
